export default __webpack_public_path__ + "449d8722dfb6d1029eed44ab4e166743.woff2";